import {
  mapTokensByChainId,
  Network,
  TokenOptions,
  TokenSymbol,
} from '@nsfw-app/crypto'
import { KnownIcon } from 'common/Icon'

export const getTokensForChainId = (chaindId: Network): TokenOptions[] => {
  return mapTokensByChainId[chaindId]
}

export const getIconForToken = (symbol: TokenSymbol): KnownIcon => {
  return `Badge${symbol}` as KnownIcon
}
